var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 0C14.3395 0 13.5 0.839466 13.5 1.875V17.625C13.5 18.6605 14.3395 19.5 15.375 19.5H16.125C17.1605 19.5 18 18.6605 18 17.625V1.875C18 0.839466 17.1605 0 16.125 0H15.375Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.375C6.75 5.33947 7.58947 4.5 8.625 4.5H9.375C10.4105 4.5 11.25 5.33947 11.25 6.375V17.625C11.25 18.6605 10.4105 19.5 9.375 19.5H8.625C7.58947 19.5 6.75 18.6605 6.75 17.625V6.375Z",
    fill: "#0F172A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.875C0 9.83947 0.839466 9 1.875 9H2.625C3.66053 9 4.5 9.83947 4.5 10.875V17.625C4.5 18.6605 3.66053 19.5 2.625 19.5H1.875C0.839466 19.5 0 18.6605 0 17.625V10.875Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.c36302961d39993d7c777d4737e7e5b9.svg";
export { ForwardRef as ReactComponent };